module.exports = __webpack_public_path__ + "static/media/push.0178673c.svg";